import {LayoutUser} from "../../models/layout-window.model";

export class UserSessionService {

    static storageKeys = {
        layoutUser: "clevermatch.layoutUser"
    };

    setLayoutUser(layoutUser: LayoutUser) {
        sessionStorage.setItem(UserSessionService.storageKeys.layoutUser, JSON.stringify(layoutUser));
    }

    getLayoutUser() {
        let layoutUser: any = sessionStorage.getItem(UserSessionService.storageKeys.layoutUser);
        if(layoutUser != null) {
            return JSON.parse(layoutUser);
        }
        return null;
    }

    getLoggedInDistrictName(): string {
        let layoutUser = this.getLayoutUser();
        if(layoutUser == null) {
            return null;
        }
        return layoutUser.districtName;
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/services/user-session/user-session.service.ts